import type { ReactNode } from 'react'

import { cn } from '@/utils'

// One pill language for the whole surface: three meanings, three tints, one
// geometry. Amber asks the user for something, neutral states a fact, brand
// says CounselPro.
const PILL_TONES = {
  amber: 'bg-amber-100 text-amber-800',
  neutral: 'bg-blue-2 text-ink-subtle',
  brand: 'bg-brand/10 text-brand-deep',
} as const

export type PillTone = keyof typeof PILL_TONES

export const SupportPill = ({
  tone,
  children,
}: {
  tone: PillTone
  children: ReactNode
}) => (
  <span
    className={cn(
      'inline-flex h-5 shrink-0 items-center whitespace-nowrap rounded-full px-2 text-xs font-medium leading-none',
      PILL_TONES[tone],
    )}
  >
    {children}
  </span>
)
